<style lang="less">
  @import "./PhotoAlbum.less";
</style>

<template>
  <div class="photo-album clear">
    <!-- <div class="photo-album-list" @click="toPhotoListPageFn(3)">
      <img class="img-icon" v-if="!voice_photo.thumb" src="../../../assets/images/album/ic_voice_photo.png" alt="">
      <img class="img-thumb" v-if="voice_photo.thumb" :src="voice_photo.thumb" alt="">
      <p>语音照片({{voice_photo.count || 0}})</p>
    </div>
    <div class="photo-album-list" @click="toPhotoListPageFn(4)">
      <img class="img-icon" v-if="!voice_video.thumb" src="../../../assets/images/album/ic_voice_photo.png" alt="">
      <img class="img-thumb" v-if="voice_video.thumb" :src="voice_video.thumb" alt="">
      <van-icon name="play" class="play" color="#ffffff" size="30"  v-if='voice_video.thumb'/>
      <p>语音视频({{voice_video.count || 0}})</p>
    </div>
    <div class="photo-album-list" @click="toPhotoListPageFn(7)">
      <img class="img-icon" v-if="!realtime_photo.thumb" src="../../../assets/images/album/ic_realtime_photo.png" alt="">
      <img class="img-thumb" v-if="realtime_photo.thumb" :src="realtime_photo.thumb" alt="">
      <p>实时拍照({{realtime_photo.count || 0}})</p>
    </div>
    <div class="photo-album-list" @click="toPhotoListPageFn(8)">
      <img class="img-icon" v-if="!realtime_video.thumb" src="../../../assets/images/album/ic_realtime_video.png" alt="">
      <img class="img-thumb" v-if="realtime_video.thumb" :src="realtime_video.thumb" alt="">
      <van-icon name="play" class="play" color="#ffffff" size="30" v-if='realtime_video.thumb'/>
      <p>实时视频({{realtime_video.count || 0}})</p>
    </div>
    <div class="photo-album-list" @click="toPhotoListPageFn(11)">
      <img class="img-icon" v-if="!accOff_photo.thumb" src="../../../assets/images/album/ic_accoff_photo.png" alt="">
      <img class="img-thumb" v-if="accOff_photo.thumb" :src="accOff_photo.thumb" alt="">
      <p>休眠震动照片({{accOff_photo.count || 0}})</p>
    </div> -->
    <!--<div class="photo-album-list" @click="toPhotoListPageFn(12)">-->
      <!--<img class="img-icon" v-if="!accOff_video.thumb" src="../../../assets/images/album/ic_accoff_photo.png" alt="">-->
      <!--<img class="img-thumb" v-if="accOff_video.thumb" :src="accOff_video.thumb" alt="">-->
      <!--<p>休眠震动视频({{accOff_video.count || 0}})</p>-->
    <!--</div>-->
    <!--<div class="photo-album-list" @click="toPhotoListPageFn(5)">-->
      <!--<img class="img-icon" v-if="!lock_photo.thumb" src="../../../assets/images/album/ic_lock_photo.png" alt="">-->
      <!--<img class="img-thumb" v-if="lock_photo.thumb" :src="lock_photo.thumb" alt="">-->
      <!--<p>行车碰撞照片({{lock_photo.count || 0}})</p>-->
    <!--</div>-->
    <!-- <div class="photo-album-list" @click="toPhotoListPageFn(6)">
      <img class="img-icon" v-if="!lock_video.thumb" src="../../../assets/images/album/ic_lock_photo.png" alt="">
      <img class="img-thumb" v-if="lock_video.thumb" :src="lock_video.thumb" alt="">
      <van-icon name="play" class="play" color="#ffffff" size="30" v-if='lock_video.thumb'/>
      <p>行车碰撞视频({{lock_video.count || 0}})</p>
    </div> -->
    <div v-for="item in listPhotoType" class="photo-album-list" @click="toPhotoListPageFn(item.type)">
      <img class="img-icon" v-if="!item.hasData" :src="item.thumb" alt="">
      <img class="img-thumb" v-if="item.hasData" :src="item.thumb" alt="">
      <p>{{item.name}}({{item.count || 0}})</p>
    </div>
  </div>
</template>

<script>
import PhotoAlbum from './PhotoAlbum.js'
export default {
  ...PhotoAlbum
}
</script>
